/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Close from './Close/index'
import Expand from './Expand/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/ExpandAction/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Expand'
let expandIsExpandedValueData = fromData.useDataFormat({ viewPath,
context: 'expand',
path: 'is_expanded',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: expandIsExpandedValueData,
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 onClick={onClick}
 type="ghost"
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<React.Fragment>
<fromFlow.When is={flowValue === 'Expand'}>
<Expand
{...childProps}
  viewPath={`${viewPath}/Expand`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Close'}>
<Close
{...childProps}
  viewPath={`${viewPath}/Close`}
/>
</fromFlow.When>
</React.Fragment>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
{children}
</React.Fragment>)
}